module.exports = __webpack_public_path__ + "img/home_buttongroup_background.5c49b387.png";